<template>
  <div v-if="isLoading" class="loading-overlay">
    <div class="loading-content">
      <div class="loading-spinner"></div>
      <p
        v-if="session.isPaypayProcessing"
        style="margin-top: 15px; font-weight: bold"
      >
        PayPay決済を確認中です...
      </p>
      <p
        v-if="session.isCreditCardProcessing"
        style="margin-top: 15px; font-weight: bold"
      >
        クレジットカード決済を処理中です...
      </p>
      <p
        v-if="session.eprintPDFSending"
        style="margin-top: 15px; font-weight: bold"
      >
        コンビニプリント番号を発行中です...
      </p>
      <p
        v-if="session.isRefundProcessing"
        style="margin-top: 15px; font-weight: bold"
      >
        返金処理を実行中です...
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  useEprintDerived,
  useEprintSession
} from '@/composables/format-edit/useEprintSession'

const session = useEprintSession()
const { isLoading } = useEprintDerived(session)
</script>
